import React, { useState, useEffect } from 'react';
import { format, parseISO } from 'date-fns';


export default function ComponentPrograms({ currentInstitution}) {
  const [loading, setLoading] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [totalItems, setTotalItems] = useState(currentInstitution.programs.length);


  useEffect(() => {

    //alert("currentInstitution: " + JSON.stringify(currentInstitution.programs, null, 2));
  }, [currentPage]);  

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentPrograms = currentInstitution.programs.slice(indexOfFirstItem, indexOfLastItem);

  let countPrograms = indexOfFirstItem + 1;

  return (
    <div>
      <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-3 gap-6 pb-2">
        <div className="flex flex-col py-2 text-sm">
          <label>Programs</label>
        </div>
      </div>


{
loading ? (
              <div className='p-4'>Loading...</div>
            ) : 
            (
              <div className='overflow-x-auto'>
                <table className='min-w-full bg-white shadow-md rounded-lg overflow-hidden'>
                  
                  <thead>
                    <tr>
                      <th style={{backgroundColor: '#095918'}} className='px-6 py-3 border-b border-gray-300 text-left text-xs leading-4 font-medium text-white uppercase tracking-wider'>
                        SN
                      </th>
                      <th style={{backgroundColor: '#095918'}} className='px-6 py-3 border-b border-gray-300 text-left text-xs leading-4 font-medium text-white uppercase tracking-wider'>
                        Id
                      </th>
                      <th style={{backgroundColor: '#095918'}} className='px-6 py-3 border-b border-gray-300 text-left text-xs leading-4 font-medium text-white uppercase tracking-wider'>
                        Program
                      </th>
                      <th style={{backgroundColor: '#095918'}} className='px-6 py-3 border-b border-gray-300 text-left text-xs leading-4 font-medium text-white uppercase tracking-wider'>
                        Type
                      </th>
                      
                    </tr>
                  </thead>
                  
                  <tbody>
                    {currentPrograms.map((program) => (
                      <tr key={program.id} >
                        <td className='px-6 py-4 whitespace-no-wrap border-b border-gray-200'>
                        {countPrograms++}
                        </td>
                        <td className='px-6 py-4 whitespace-no-wrap border-b border-gray-200'>
                          {program.id}
                        </td>
                        <td className='px-6 py-4 whitespace-no-wrap border-b border-gray-200'>
                          {program.program}
                        </td>
                        <td className='px-6 py-4 whitespace-no-wrap border-b border-gray-200'>
                          {program.type}
                        </td>
                        
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )
            }


    </div>
  );
}
